export const CONFIG_CLIENT = {
    CLIENT_STORAGE: 'configClient',
    DEFAULT: 'default'
};